<template>
  <div id="header" style="z-index: 2000;">
    <div class="container header-container" style="z-index: 2000;">
      <div class="title-container">
        <img @click="$router.push({ name: 'home' })" class="logo" src="@/assets/logo.png">
      </div>
      <template v-if="!mobile">
        <div style="list-style: none; display: flex; align-items: center;">
          <li class="header-menu-item" style="margin: 0 10px;">
            <router-link :to="{ name: 'senate_landing' }" :style="$route.name === 'senate_landing' ? 'font-weight: 500; color: #666;' : ''">Senate Model</router-link>
          </li>
          <li class="header-menu-item" style="margin: 0 10px;">
            <router-link :to="{ name: 'house_landing' }" :style="$route.name === 'house_landing' ? 'font-weight: 500; color: #666;' : ''">House Model</router-link>
          </li>
          <!-- <li class="header-menu-item" style="margin: 0 10px;">
            <router-link :to="{ name: 'calculator' }" :style="$route.name === 'calculator' ? 'font-weight: 500; color: #666;' : ''">Forecasting Simulator</router-link>
          </li> -->
          <v-btn
            class="nav-btn mobile-nav-btn"
            flat
            icon
            :color="showMenu ? 'black' : 'grey'"
            @click="toggleMenu">
            <v-icon>menu</v-icon>
          </v-btn>
        </div>
      </template>
      <template v-else>
        <div class="nav-container" v-if="screenWidth > 600">
          <v-btn
            class="nav-btn"
            flat
            :color="showSearch ? 'black' : 'grey'"
            @click="toggleSearch">
            <span class="mr-2">Search Races </span>
            <v-icon>search</v-icon>
          </v-btn>
          <v-btn
            class="nav-btn"
            flat
            :color="showTimeline ? 'black' : 'grey'"
            @click="toggleTimeline">
            <span class="mr-2">Timeline </span>
            <v-icon>timeline</v-icon>
          </v-btn>
          <v-btn
            class="nav-btn"
            flat
            :color="showMenu ? 'black' : 'grey'"
            @click="toggleMenu">
            <span class="mr-2">Menu </span>
            <v-icon>menu</v-icon>
          </v-btn>
        </div>
        <div class="nav-container" v-else>
          <v-btn
            class="nav-btn mobile-nav-btn"
            flat
            icon
            :color="showSearch ? 'black' : 'grey'"
            @click="toggleSearch">
            <v-icon>search</v-icon>
          </v-btn>
          <v-btn
            class="nav-btn mobile-nav-btn"
            flat
            icon
            :color="showTimeline ? 'black' : 'grey'"
            @click="toggleTimeline">
            <v-icon>timeline</v-icon>
          </v-btn>
          <v-btn
            class="nav-btn mobile-nav-btn"
            flat
            icon
            :color="showMenu ? 'black' : 'grey'"
            @click="toggleMenu">
            <v-icon>menu</v-icon>
          </v-btn>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

const name = 'fc_header'

const computed = {
  ...mapGetters({
    mobile: 'ux/mobile',
    screenWidth: 'ux/screenWidth',
    showMenu: 'ux/menu',
    showSearch: 'ux/search',
    showTimeline: 'ux/timeline'
  })
}

const methods = {
  ...mapActions({
    toggleClosed: 'ux/toggleClosed',
    toggleMenu: 'ux/toggleMenu',
    toggleSearch: 'ux/toggleSearch',
    toggleTimeline: 'ux/toggleTimeline'
  }),
  logout () {
    this.$auth.logout()
    if ((this.$route.meta || {}).auth === true) {
      this.$router.push('/')
    }
  },
  onScroll () {
    const header = document.getElementById('header')
    const scrollTop = window.scrollY
    if (scrollTop > 10 && !header.classList.contains('fixed-header')) {
      header.classList.add('fixed-header')
    }
    if (scrollTop < 10 && header.classList.contains('fixed-header')) {
      header.classList.remove('fixed-header')
    }
    if (this.showTimeline) {
      this.toggleTimeline(false)
    }
  }
}

const watch = {
  '$route' () {
    this.toggleClosed()
  },
  showSearch () {
    if (this.showSearch) {
      document.getElementById('election-search-input').focus()
      document.querySelector('html').style.overflow = 'hidden'
    } else {
      document.querySelector('html').style.overflow = 'auto'
    }
  }
}

export default {
  name,
  computed,
  methods,
  watch,
  data () {
    return {
      isIE11: false
    }
  },
  mounted () {
    this.isIE11 = !!window.MSInputMethodContext && !!document.documentMode
    if (this.isIE11) {
      const header = document.getElementById('header')
      header.classList.add('fixed-header')
    } else {
      window.addEventListener('scroll', () => {
        this.onScroll()
      })
    }
  },
  beforeDestroy () {
    if (!this.isIE11) {
      window.removeEventListener('scroll', () => {
        this.onScroll()
      })
    }
  }
}
</script>

<style>
.header-container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  justify-content: space-between;
}

.nav-container {
  padding-bottom: 10px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  align-items: center;
}

.logo {
  height: 45px;
  cursor: pointer;
}

.nav-btn {
  margin: 0px;
  margin-left: 10px;
}

.nav-btn .btn__content {
  padding: 0px;
  letter-spacing: 0px;
  opacity: 0.75;
}

.nav-btn .btn--plain {
  height: auto;
  width: auto;
  margin: 0;
  padding: 8px;
  min-width: 0;
}

.nav-btn .btn__content:before {
  background-color: transparent !important;
  transition: none !important;
}

.nav-btn .btn__content:hover {
  opacity: 1;
}

.header-menu-item a {
  color: #9E9E9E;
  letter-spacing: 0.03em;
}

.mobile-nav-btn {
  margin: 0 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/Header.vue